// /:elemental_url/:id/duplicate

import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { duplicateElemental } from '~~/src/api/elementals'
import { ElementalTypeEnum, ElementalTypeRoutes } from '~~/src/types/elemental'

const listIdIsValid = (listId?: string | number) => {
  if (!listId)
    return false
  return !isNaN(Number(listId))
}

export const useDuplicateElemental = () => {
  const queryClient = useQueryClient()
  return useMutation<
    Awaited<ReturnType<typeof duplicateElemental>>,
    Error,
    {
      elementalType: ElementalTypeEnum
      elementalId: string
      listId?: string | number
    }
  >({
    mutationKey: ['duplicate-elemental'],
    mutationFn: async ({ elementalType, elementalId, listId }) => {
      const validListid = listIdIsValid(listId) ? listId : undefined
      const route = ElementalTypeRoutes[elementalType]
      if (route === 'unknown')
        throw new Error('Unknown elemental type')
      return await duplicateElemental(`${route}s`, elementalId, validListid)
    },
    onError: (_, { elementalType }) => {
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
    },
    onSuccess: (result, { elementalType, listId }) => {
      if (elementalType === ElementalTypeEnum.List && result) {
        queryClient.invalidateQueries({
          queryKey: ['profile-list-elementals', result?.elementalTypeId],
          exact: false,
          type: 'all',
        })

        queryClient.refetchQueries({
          queryKey: ['profile-list-elementals', result?.elementalTypeId],
          exact: false,
          type: 'all',
        })

        return
      }
      if (listIdIsValid(listId)) {
        queryClient.invalidateQueries({
          queryKey: ['list-elementals', listId],
          exact: false,
          type: 'all',
        })
        queryClient.refetchQueries({
          queryKey: ['list-elementals', listId],
          exact: false,
          type: 'all',
        })
        return
      }
      queryClient.invalidateQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
    },
  })
}
